export enum SortOptions {
    name_asc,
    name_desc,
    date_asc,
    date_desc,
    connection_asc,
    connection_desc,
    status_asc,
    status_desc,
    url_asc,
    url_desc
}
